import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "club"
  }, [_c("div", {
    staticClass: "list"
  }, _vm._l(_vm.clubList, function (item) {
    return _c("div", {
      key: item.threadId,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId);
        }
      }
    }, [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("van-image", {
      attrs: {
        fit: "cover",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e(), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 && item["content"]["indexes"]["101"]["body"][0].type == 2 ? _c("video", {
      attrs: {
        controls: "",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e(), _c("div", {
      staticClass: "text-con"
    }, [_c("h4", [_vm._v(_vm._s(item.title))]), _c("span", {
      staticClass: "activity-span",
      domProps: {
        textContent: _vm._s(item.content.text)
      }
    })])], 1);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };